export var buildQueryFromKeyValuePairs = function (pairs) {
    return pairs.filter(function (_a) {
        var value = _a.value;
        return (typeof value === 'string' && !!value)
            || typeof value === 'number'
            || typeof value === 'boolean';
    })
        .map(function (_a) {
        var key = _a.key, value = _a.value, transform = _a.transform;
        return (key + "=" + (transform ? transform(value) : value));
    })
        .join('&');
};
